import React from "react";
import Navbar from "../../components/navigation/Navbar";
import Footer from "../../components/footer/Footer";
import { Link, useNavigate } from "react-router-dom";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import SmartphoneIcon from "@mui/icons-material/Smartphone";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import productsJson from "../../components/jsonData";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import { ProductContext } from "../../Contexts/ProductContext";
import { Skeleton } from "@mui/material";

const ProductListing = () => {
  const { products, loading } = React.useContext(ProductContext);
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const apiUrl = process.env.REACT_APP_API_URL;
  const [filteredProducts, setFilteredProducts] = React.useState([]);
  const [ploading, setpLoading] = React.useState(true);
  const [selectedProduct, setSelectedProduct] = React.useState(null); // For the modal
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const [comment, setComment] = React.useState("");
  const navigate = useNavigate();

  const [filterShow, setfilterShow] = React.useState(false);
  const toggleFilter = () => {
    setfilterShow((prevState) => !prevState);
  };

  // Filter states
  const [salesMethod, setSalesMethod] = React.useState([]);
  const [industry, setIndustry] = React.useState([]);
  const [brand, setBrand] = React.useState([]);
  const [type, setType] = React.useState([]);
  const [condition, setCondition] = React.useState([]);

  const handleFilterChange = (e, filterType) => {
    const { value, checked } = e.target;

    switch (filterType) {
      case "salesMethod":
        setSalesMethod((prev) =>
          checked ? [...prev, value] : prev.filter((v) => v !== value)
        );
        break;
      case "industry":
        setIndustry((prev) =>
          checked ? [...prev, value] : prev.filter((v) => v !== value)
        );
        break;
      case "prdBrand":
        setBrand((prev) =>
          checked ? [...prev, value] : prev.filter((v) => v !== value)
        );
        break;
      case "prdType":
        setType((prev) =>
          checked ? [...prev, value] : prev.filter((v) => v !== value)
        );
        break;
      case "prdCondition":
        setCondition((prev) =>
          checked ? [...prev, value] : prev.filter((v) => v !== value)
        );
        break;
      default:
        break;
    }
  };

  React.useEffect(() => {
    if (!loading && products.length > 0) {
      setpLoading(true);
      const sortedProducts = products.sort(
        (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
      );
      setFilteredProducts(sortedProducts);
      setpLoading(false);
    } else {
      // toast.error("Failed to fetch products");
    }
  }, [loading, products]);

  const formatProductTitle = (title, id) => {
    const formattedTitle = title.split(" ").join("-");
    return `/productDetail/${formattedTitle}/${id}`;
  };

  React.useEffect(() => {
    const applyFilters = () => {
      let filtered = products;

      if (salesMethod.length > 0) {
        filtered = filtered.filter((product) =>
          salesMethod.includes(product.prdCategory)
        );
      }

      if (industry.length > 0) {
        filtered = filtered.filter((product) =>
          industry.includes(product.prdIndustry)
        );
      }

      if (brand.length > 0) {
        filtered = filtered.filter((product) =>
          brand.includes(product.prdBrand)
        );
      }

      if (type.length > 0) {
        filtered = filtered.filter((product) => type.includes(product.prdType));
      }

      if (condition.length > 0) {
        filtered = filtered.filter((product) =>
          condition.includes(product.prdCondition)
        );
      }

      setFilteredProducts(filtered);
    };

    applyFilters();
  }, [salesMethod, industry, brand, type, condition, productsJson]);

  const checkIfLoggedIn = () => {
    return localStorage.getItem("Fttoken") !== null;
  };

  const handleShowInterestClick = (product) => {
    if (!checkIfLoggedIn()) {
      toast.warn(
        "You need to be logged in to show interest, It will automatically redirect to the login page."
      );
      setTimeout(() => {
        navigate("/login");
      }, 3000);
      return;
    }
    setSelectedProduct(product); // Set the product for the modal
    setIsModalOpen(true); // Open modal
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
    setSelectedProduct(null);
    setComment("");
  };

  const handleCommentSubmit = async () => {
    const userId = localStorage.getItem("FtIdUser");
    const productId = selectedProduct._id;
    const prdcomment = comment;
    if (!userId) {
      toast.warn("You need to be logged in to submit interest.");
      return;
    }

    const interestData = {
      productId: productId,
      userId: userId,
      comment: prdcomment,
    };

    try {
      const response = await axios.post(`${apiUrl}/addInterest`, interestData);

      if (response.status === 200) {
        toast.success("Interest submitted successfully!");
        handleModalClose();
        setSelectedProduct(null);
        setComment("");
      } else {
        toast.error(`Failed to submit interest. Status: ${response.status}`);
      }
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        toast.error(`Error: ${error.response.data.message}`);
      } else {
        toast.error("An error occurred. Please try again later.");
      }
    }
  };
  return (
    <div>
      <Navbar />
      <div className="page-header p-10">
        <ToastContainer />
        <div className="container">
          <ul className="flex gap-2 items-center">
            <Link to="/" className="text-sm text-[#003245]">
              Home
            </Link>
            <span className="text-[11px]">/</span>
            <Link to="/" className="text-sm text-[#003245]">
              Products
            </Link>
            <span className="text-[11px]">/</span>
            <Link to="/productlists" className="text-sm text-[#D9D9D9]">
              Products Listing
            </Link>
          </ul>
        </div>
      </div>

      <div className="container">
        <div className="flex gap-10">
          <button className="filter-btn" onClick={toggleFilter}>
            <FilterAltIcon sx={{ color: "#003245", fontSize: "18px" }} />{" "}
            {filterShow ? "Close" : "Filters"}
          </button>
          <div
            className={`basis-[30%] filter-wrap ${
              filterShow ? "active" : "notactive"
            }`}
          >
            <div className="filter-hdng">
              <h1>Filters</h1>
              <span>Reset</span>
            </div>
            <div className="filter-body">
              <Accordion defaultExpanded>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1-content"
                  id="panel1-header"
                >
                  <Typography>Sales Methods</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>
                    <ul className="filter-box">
                      <label>
                        <input
                          type="checkbox"
                          value="Rent"
                          onChange={(e) => handleFilterChange(e, "salesMethod")}
                        />
                        Rent
                      </label>

                      <label>
                        <input
                          type="checkbox"
                          value="Buy"
                          onChange={(e) => handleFilterChange(e, "salesMethod")}
                        />
                        Buy
                      </label>
                    </ul>
                  </Typography>
                </AccordionDetails>
              </Accordion>
              <Accordion defaultExpanded>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel2-content"
                  id="panel2-header"
                >
                  <Typography>Industry</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>
                    <ul className="filter-box">
                      <label>
                        <input
                          type="checkbox"
                          value="Construction"
                          onChange={(e) => handleFilterChange(e, "industry")}
                        />
                        Construction
                      </label>

                      <label>
                        <input
                          type="checkbox"
                          value="Quarry & Aggregate"
                          onChange={(e) => handleFilterChange(e, "industry")}
                        />
                        Quarry & Aggregate
                      </label>

                      <label>
                        <input
                          type="checkbox"
                          value="Mining"
                          onChange={(e) => handleFilterChange(e, "industry")}
                        />
                        Mining
                      </label>

                      <label>
                        <input
                          type="checkbox"
                          value="Oil & Gas"
                          onChange={(e) => handleFilterChange(e, "industry")}
                        />
                        Oil & Gas
                      </label>
                    </ul>
                  </Typography>
                </AccordionDetails>
              </Accordion>

              <Accordion defaultExpanded>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel4-content"
                  id="panel4-header"
                >
                  <Typography>Product Type</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>
                    <ul className="filter-box">
                      <label>
                        <input
                          type="checkbox"
                          value="Mobile Cranes"
                          onChange={(e) => handleFilterChange(e, "prdType")}
                        />
                        Mobile Cranes
                      </label>
                      <label>
                        <input
                          type="checkbox"
                          value="Forklifts"
                          onChange={(e) => handleFilterChange(e, "prdType")}
                        />
                        Forklifts
                      </label>

                      <label>
                        <input
                          type="checkbox"
                          value="Excavators"
                          onChange={(e) => handleFilterChange(e, "prdType")}
                        />
                        Excavators
                      </label>

                      <label>
                        <input
                          type="checkbox"
                          value="Loaders"
                          onChange={(e) => handleFilterChange(e, "prdType")}
                        />
                        Loaders
                      </label>

                      <label>
                        <input
                          type="checkbox"
                          value="Rollers"
                          onChange={(e) => handleFilterChange(e, "prdType")}
                        />
                        Rollers
                      </label>

                      <label>
                        <input
                          type="checkbox"
                          value="Crawler Cranes"
                          onChange={(e) => handleFilterChange(e, "prdType")}
                        />
                        Crawler Cranes
                      </label>

                      <label>
                        <input
                          type="checkbox"
                          value="Crawler Dozers"
                          onChange={(e) => handleFilterChange(e, "prdType")}
                        />
                        Crawler Dozers
                      </label>

                      <label>
                        <input
                          type="checkbox"
                          value="Wheel Loaders"
                          onChange={(e) => handleFilterChange(e, "prdType")}
                        />
                        Wheel Loaders
                      </label>

                      <label>
                        <input
                          type="checkbox"
                          value="Compactors"
                          onChange={(e) => handleFilterChange(e, "prdType")}
                        />
                        Compactors
                      </label>
                    </ul>
                  </Typography>
                </AccordionDetails>
              </Accordion>

              <Accordion defaultExpanded>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel3-content"
                  id="panel3-header"
                >
                  <Typography>Product Brand</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>
                    <ul className="filter-box">
                      <label>
                        <input
                          type="checkbox"
                          value="Kato"
                          onChange={(e) => handleFilterChange(e, "prdBrand")}
                        />
                        Kato
                      </label>

                      <label>
                        <input
                          type="checkbox"
                          value="Tadano"
                          onChange={(e) => handleFilterChange(e, "prdBrand")}
                        />
                        Tadano
                      </label>

                      <label>
                        <input
                          type="checkbox"
                          value="Sany"
                          onChange={(e) => handleFilterChange(e, "prdBrand")}
                        />
                        Sany
                      </label>

                      <label>
                        <input
                          type="checkbox"
                          value="Sumitomo"
                          onChange={(e) => handleFilterChange(e, "prdBrand")}
                        />
                        Sumitomo
                      </label>

                      <label>
                        <input
                          type="checkbox"
                          value="Liebherr"
                          onChange={(e) => handleFilterChange(e, "prdBrand")}
                        />
                        Liebherr
                      </label>

                      <label>
                        <input
                          type="checkbox"
                          value="Zoomlion"
                          onChange={(e) => handleFilterChange(e, "prdBrand")}
                        />
                        Zoomlion
                      </label>

                      <label>
                        <input
                          type="checkbox"
                          value="Terex"
                          onChange={(e) => handleFilterChange(e, "prdBrand")}
                        />
                        Terex
                      </label>

                      <label>
                        <input
                          type="checkbox"
                          value="Xcmg"
                          onChange={(e) => handleFilterChange(e, "prdBrand")}
                        />
                        Xcmg
                      </label>
                    </ul>
                  </Typography>
                </AccordionDetails>
              </Accordion>

              <Accordion defaultExpanded>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel4-content"
                  id="panel4-header"
                >
                  <Typography>Condition</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>
                    <ul className="filter-box">
                      <label>
                        <input
                          type="checkbox"
                          value="Brand New"
                          onChange={(e) =>
                            handleFilterChange(e, "prdCondition")
                          }
                        />
                        Brand New
                      </label>

                      <label>
                        <input
                          type="checkbox"
                          value="Used"
                          onChange={(e) =>
                            handleFilterChange(e, "prdCondition")
                          }
                        />
                        Used
                      </label>
                    </ul>
                  </Typography>
                </AccordionDetails>
              </Accordion>
            </div>
          </div>

          <div className="basis-[70%] filter-products">
            <div className="filter-product-hdngs">
              <h1 className="">Product Listing</h1>
              <span className="product-count">
                {filteredProducts.length} Products
              </span>
            </div>
            {ploading ? (
              <div>
                {[1, 2, 3, 4, 5].map((item) => (
                  <ProductSkeleton key={item} />
                ))}
              </div>
            ) : filteredProducts.length > 0 ? (
              filteredProducts.map((Eproduct) => (
                <div className="product-card product-flexer" key={Eproduct._id}>
                  <div className="product-image">
                    <img
                      src={Eproduct.images[0] || "default-image.jpg"}
                      alt={Eproduct.title}
                    />
                    {Eproduct?.prdStock === "Out of Stock" &&
                    Eproduct?.prdCategory === "Rent" ? (
                      <span className="stockTag">Rent Out</span>
                    ) : Eproduct?.prdStock === "Out of Stock" &&
                      Eproduct?.prdCategory === "Buy" ? (
                      <span className="stockTag">Sold Out</span>
                    ) : null}
                  </div>
                  <div className="product-info relative">
                    {Eproduct.prdCategory === "Buy" ? (
                      <span className="pCtg-green abosl">For Sale</span>
                    ) : (
                      <span className="pCtg-red abosl">For Rent</span>
                    )}
                    <h2>{Eproduct.title}</h2>
                    <div className="specs-wrap">
                      <div className="specs">
                        <p>Model:</p>
                        {Eproduct.prdModel ? (
                          <span>{Eproduct.prdModel}</span>
                        ) : (
                          <span>---</span>
                        )}
                      </div>

                      <div className="specs">
                        <p>Operating Weight:</p>
                        {Eproduct.opr_weight ? (
                          <span>{Eproduct.opr_weight} KGs</span>
                        ) : (
                          <span>---</span>
                        )}
                      </div>

                      <div className="specs">
                        <p>Brand:</p>
                        {Eproduct.prdBrand ? (
                          <span>{Eproduct.prdBrand}</span>
                        ) : (
                          <span>---</span>
                        )}
                      </div>

                      <div className="specs">
                        <p>Condition:</p>
                        {Eproduct.prdCondition ? (
                          <span>{Eproduct.prdCondition}</span>
                        ) : (
                          <span>---</span>
                        )}
                      </div>
                    </div>

                    <div className="sharing-btn">
                      <span>Share:</span>
                      <a
                        href={`https://wa.me/971501501145?text=Hi,%20I'd%20like%20to%20learn%20more%20about%20this%20product. ${baseUrl}${formatProductTitle(
                          Eproduct.title,
                          Eproduct._id
                        )}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <WhatsAppIcon
                          sx={{
                            fontSize: "17px",
                            color: "#F84E59",
                            marginRight: "8px",
                          }}
                        />
                      </a>
                      <a
                        href={`mailto:info@agacrane.com?subject=Need%20information%20about%20this%20product. ${baseUrl}${formatProductTitle(
                          Eproduct.title,
                          Eproduct._id
                        )}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <MailOutlineIcon
                          sx={{
                            fontSize: "17px",
                            color: "#F84E59",
                            marginRight: "8px",
                          }}
                        />
                      </a>
                      <a
                        href="tel:+971501501145"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <SmartphoneIcon
                          sx={{ fontSize: "17px", color: "#F84E59" }}
                        />
                      </a>
                    </div>

                    <div className="flex gap-5 mt-5">
                      <button
                        className="btn-interest btn-list"
                        onClick={() => handleShowInterestClick(Eproduct)}
                      >
                        Show Interest
                      </button>
                      <Link
                        to={formatProductTitle(Eproduct.title, Eproduct._id)}
                        className="btn-details btn-list"
                      >
                        See Details
                      </Link>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <p className="text-sm">Currently No products available...</p>
            )}
          </div>
        </div>
      </div>
      <Footer />

      {/* Modal for Show Interest */}
      <Dialog
        open={isModalOpen}
        onClose={handleModalClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Review Product and Send to Us."}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {selectedProduct && (
              <>
                <div className="product-modal-wrap">
                  <div>
                    <img
                      src={selectedProduct.images[0] || "default-image.jpg"}
                      alt={selectedProduct.title}
                    />
                  </div>
                  <div className="product-info relative">
                    {selectedProduct.prdCategory === "Buy" ? (
                      <span className="pCtg-green abosl">For Sale</span>
                    ) : (
                      <span className="pCtg-red abosl">For Rent</span>
                    )}
                    <h2>{selectedProduct.title}</h2>
                    <div className="specs-wrap">
                      <div className="specs">
                        <p>Engine Power:</p>
                        <span>{`${selectedProduct.enginePower} HP`}</span>
                      </div>

                      <div className="specs">
                        <p>Operating Weight:</p>
                        <span>{`${selectedProduct.opr_weight} KGs`}</span>
                      </div>

                      <div className="specs">
                        <p>Brand:</p>
                        {selectedProduct.prdBrand ? (
                          <span>{selectedProduct.prdBrand}</span>
                        ) : (
                          <span>---</span>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="form-group mb-5 mt-5">
                  <label className="text-sm mb-2 pl-1 block font-medium">
                    Your Comments
                  </label>
                  <textarea
                    rows={4}
                    className="form-control"
                    value={comment}
                    onChange={(e) => setComment(e.target.value)}
                    name="comment"
                  ></textarea>
                </div>
              </>
            )}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCommentSubmit} autoFocus className="modalBTN">
            Submit
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default ProductListing;

// Add this component inside ProductListing but before the return statement
const ProductSkeleton = () => (
  <div className="product-card product-flexer">
    <div className="product-image">
      <Skeleton variant="rectangular" width="100%" height={250} />
    </div>
    <div className="product-info relative">
      <Skeleton
        variant="rectangular"
        width={80}
        height={24}
        style={{ position: "absolute", right: 20, top: 20 }}
      />
      <Skeleton
        variant="text"
        width="70%"
        height={32}
        style={{ marginBottom: 15 }}
      />

      <div className="specs-wrap">
        <div className="specs">
          <Skeleton variant="text" width={60} />
          <Skeleton variant="text" width={100} />
        </div>
        <div className="specs">
          <Skeleton variant="text" width={60} />
          <Skeleton variant="text" width={100} />
        </div>
        <div className="specs">
          <Skeleton variant="text" width={60} />
          <Skeleton variant="text" width={100} />
        </div>
        <div className="specs">
          <Skeleton variant="text" width={60} />
          <Skeleton variant="text" width={100} />
        </div>
      </div>

      <div className="sharing-btn">
        <Skeleton variant="text" width={200} />
      </div>

      <div className="flex gap-5 mt-5">
        <Skeleton variant="rectangular" width={120} height={40} />
        <Skeleton variant="rectangular" width={120} height={40} />
      </div>
    </div>
  </div>
);
